import { some } from 'lodash'
import store from '@/store'

export default {
  hasAnyRole(roles, byPassAsAdmin) {
    if (byPassAsAdmin === undefined) {
      byPassAsAdmin = true
    }
    const isAdmin = some(store.state.Session.session.user.authorities, { authority: 'ROLE_ADMIN' })

    return (byPassAsAdmin && isAdmin) || some(roles, role =>
      some(store.state.Session.session.user.authorities, authority => authority.authority === role))
  }
}



// WEBPACK FOOTER //
// ./src/common/UserService.js